import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { OrganizationBillingFacade } from '../../../../../Facades/Organizations/organization-billing.facade';
import { DATE_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { BILLING_DOCUMENTS_LINK_LABEL } from '../../../../../Consts/billing.const';
import { INVOICE_STATUS_LABEL, INVOICE_STATUS_OPTIONS } from '../../../../../Enums/stripe-status.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'av-organization-invoices',
  standalone: true,
  imports: [
    RouterLink,
    DatePipe,
    DecimalPipe,
    MatIconModule,
    MatTooltipModule,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvStatusChipComponent,
    TranslateModule,
  ],
  templateUrl: './organization-invoices.component.html',
  styleUrl: './organization-invoices.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class OrganizationInvoicesComponent {
  readonly facade = inject(OrganizationBillingFacade);

  readonly organizationId = input<string>('');

  readonly dateFormat = DATE_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;
  readonly documentsLinkLabel = BILLING_DOCUMENTS_LINK_LABEL;
  readonly statusOptions = INVOICE_STATUS_OPTIONS;
  readonly statusLabelKeys = INVOICE_STATUS_LABEL;

  readonly isEmpty = computed<boolean>(
    () => this.facade.invoicesState() === 'ready' && this.facade.invoices().length === 0,
  );

  filterStatus(value: string): void {
    this.facade.filterInvoices(value);
  }

  goToPage(page: number): void {
    this.facade.goToInvoicePage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }
}
